package analytics

interface AnalyticsLogger {
    fun d(message: String)
    fun e(message: String, error: Throwable? = null)

    companion object {
        val None: AnalyticsLogger = object : AnalyticsLogger {
            override fun d(message: String) = Unit
            override fun e(message: String, error: Throwable?) = Unit
        }

        val Println: AnalyticsLogger = object : AnalyticsLogger {
            override fun d(message: String) = println("[analytics] $message")
            override fun e(message: String, error: Throwable?) {
                println("[analytics] ERROR $message")
                error?.printStackTrace()
            }
        }
    }
}
